import { useState, useEffect } from 'react';
import { miners } from '../utils/miners';
import { MinerSpec } from '../utils/minerTypes';

export function useMinerDetails(model: string | undefined) {
  const [miner, setMiner] = useState<MinerSpec | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!model) {
      setIsLoading(false);
      setError('No miner model provided');
      return;
    }

    try {
      // Find miner in local data
      const foundMiner = miners.find(m => m.model === model);
      
      if (foundMiner) {
        setMiner(foundMiner);
        setError(null);
      } else {
        setMiner(null);
        setError('Miner not found');
      }
    } catch (err) {
      console.error('Error fetching miner details:', err);
      setError('Failed to load miner details');
      setMiner(null);
    } finally {
      setIsLoading(false);
    }
  }, [model]);

  return { miner, isLoading, error };
}